// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* review-carousel START */
.review-carousel-container {
  --carousel-control-height: 22px;
  --carousel-control-min-width: 0px;
  --carousel-control-side-padding: 0px;
  --carousel-control-inner-margin: 0px;
  --carousel-min-max-width: 370px;
  display: flex;
  justify-content: center;
  max-width: 100%;
}

.review-carousel {
  display: flex;
  flex-direction: column;
  border-radius: 9px;
}

.review-carousel {
  background: var(--very-light-gray);

  max-width: min(
          var(--carousel-min-max-width),
          calc(
                  100% -
                  (
                  var(--carousel-control-min-width) + var(--carousel-control-inner-margin) +
                  var(--carousel-control-side-padding)
                  ) * 2
          )
  );
}

@media screen and (max-width: 960px) {
  .review-carousel {
    width: auto;
  }
}

.review-carousel .review-container {
  padding: 27px 25px 30px 18px;
  background-color: var(--white);
  border-radius: 16px;
  margin: auto 8px;
}

.review-carousel .review-username {
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;

  margin-top: 13px;
}

.review-carousel .review-rating {
  display: flex;
  margin-top: 3px;
  margin-left: -4px;
  margin-bottom: 20px;
  flex-direction: row-reverse;
  -webkit-box-pack: justify;
  justify-content: space-between;

}

.review-carousel .review-rating .star-container {
  display: flex;
  gap: 5px;
}

.review-carousel .review-rating .personal-information {
  display: flex;
}

.review-carousel .review-rating .personal-information img {
  width: 40px;
}


.review-carousel .review-rating .personal-information .comment-info {
  margin: 0 0 0 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.review-carousel .review-rating .personal-information .comment-info .nickname {
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
}


.review-carousel .review-rating .personal-information .comment-info .data {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--dark-gray);
}

.review-carousel .review-body {
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
}

.review-carousel .slick-dots {
  margin-top: 32px;
  display: flex !important;
  justify-content: center;
  list-style: none;
}

.review-carousel .slick-dots li {
  --pagination-dot-size: 8px;
  display: inline-block;
  width: var(--pagination-dot-size);
  height: var(--pagination-dot-size);
  margin: 0 3px;
  padding: 0;
  cursor: pointer;
}

.review-carousel .slick-dots li button {
  position: relative;
  font-size: 0;
  line-height: 0;
  display: block;
  width: var(--pagination-dot-size);
  height: var(--pagination-dot-size);
  padding: 0;
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  background: transparent;
}

.review-carousel .slick-dots li button:before {
  line-height: var(--pagination-dot-size);
  position: absolute;
  top: 0;
  left: 0;
  width: var(--pagination-dot-size);
  height: var(--pagination-dot-size);
  content: '';
  background-color: #dfdfdf;
  border-radius: 50%;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.review-carousel .slick-dots li.slick-active button:before {
  background-color: var(--black);
}

/*
.slick-dots{
    position: absolute;
    bottom: -25px;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
}
*/

.review-carousel-container .control {
  display: flex;
  align-items: center;
  cursor: pointer;
  min-width: var(--carousel-control-min-width);
}

.review-carousel-container .control img {
  height: var(--carousel-control-height);
  min-width: var(--carousel-control-min-width);
}

.review-carousel-container .right-control {
  margin-left: var(--carousel-control-inner-margin);
  padding-right: var(--carousel-control-side-padding);
}

.review-carousel-container .right-control img {
  transform: rotate(0.5turn);
}

.review-carousel-container .left-control {
  margin-right: var(--carousel-control-inner-margin);
  padding-left: var(--carousel-control-side-padding);
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.review.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,oCAAoC;EACpC,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;;EAElC;;;;;;;;;GASC;AACH;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,8BAA8B;;AAEhC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,iCAAiC;EACjC,kCAAkC;EAClC,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iCAAiC;EACjC,kCAAkC;EAClC,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;;;;;;CAWC;;AAED;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;EAClD,kDAAkD;AACpD","sourcesContent":["/* review-carousel START */\n.review-carousel-container {\n  --carousel-control-height: 22px;\n  --carousel-control-min-width: 0px;\n  --carousel-control-side-padding: 0px;\n  --carousel-control-inner-margin: 0px;\n  --carousel-min-max-width: 370px;\n  display: flex;\n  justify-content: center;\n  max-width: 100%;\n}\n\n.review-carousel {\n  display: flex;\n  flex-direction: column;\n  border-radius: 9px;\n}\n\n.review-carousel {\n  background: var(--very-light-gray);\n\n  max-width: min(\n          var(--carousel-min-max-width),\n          calc(\n                  100% -\n                  (\n                  var(--carousel-control-min-width) + var(--carousel-control-inner-margin) +\n                  var(--carousel-control-side-padding)\n                  ) * 2\n          )\n  );\n}\n\n@media screen and (max-width: 960px) {\n  .review-carousel {\n    width: auto;\n  }\n}\n\n.review-carousel .review-container {\n  padding: 27px 25px 30px 18px;\n  background-color: var(--white);\n  border-radius: 16px;\n  margin: auto 8px;\n}\n\n.review-carousel .review-username {\n  font-weight: 600;\n  font-size: 15px;\n  line-height: 18px;\n\n  margin-top: 13px;\n}\n\n.review-carousel .review-rating {\n  display: flex;\n  margin-top: 3px;\n  margin-left: -4px;\n  margin-bottom: 20px;\n  flex-direction: row-reverse;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n\n}\n\n.review-carousel .review-rating .star-container {\n  display: flex;\n  gap: 5px;\n}\n\n.review-carousel .review-rating .personal-information {\n  display: flex;\n}\n\n.review-carousel .review-rating .personal-information img {\n  width: 40px;\n}\n\n\n.review-carousel .review-rating .personal-information .comment-info {\n  margin: 0 0 0 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.review-carousel .review-rating .personal-information .comment-info .nickname {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 19px;\n}\n\n\n.review-carousel .review-rating .personal-information .comment-info .data {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--dark-gray);\n}\n\n.review-carousel .review-body {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 21px;\n}\n\n.review-carousel .slick-dots {\n  margin-top: 32px;\n  display: flex !important;\n  justify-content: center;\n  list-style: none;\n}\n\n.review-carousel .slick-dots li {\n  --pagination-dot-size: 8px;\n  display: inline-block;\n  width: var(--pagination-dot-size);\n  height: var(--pagination-dot-size);\n  margin: 0 3px;\n  padding: 0;\n  cursor: pointer;\n}\n\n.review-carousel .slick-dots li button {\n  position: relative;\n  font-size: 0;\n  line-height: 0;\n  display: block;\n  width: var(--pagination-dot-size);\n  height: var(--pagination-dot-size);\n  padding: 0;\n  cursor: pointer;\n  color: transparent;\n  border: 0;\n  outline: none;\n  background: transparent;\n}\n\n.review-carousel .slick-dots li button:before {\n  line-height: var(--pagination-dot-size);\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: var(--pagination-dot-size);\n  height: var(--pagination-dot-size);\n  content: '';\n  background-color: #dfdfdf;\n  border-radius: 50%;\n  text-align: center;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.review-carousel .slick-dots li.slick-active button:before {\n  background-color: var(--black);\n}\n\n/*\n.slick-dots{\n    position: absolute;\n    bottom: -25px;\n    display: block;\n    width: 100%;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    text-align: center;\n}\n*/\n\n.review-carousel-container .control {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  min-width: var(--carousel-control-min-width);\n}\n\n.review-carousel-container .control img {\n  height: var(--carousel-control-height);\n  min-width: var(--carousel-control-min-width);\n}\n\n.review-carousel-container .right-control {\n  margin-left: var(--carousel-control-inner-margin);\n  padding-right: var(--carousel-control-side-padding);\n}\n\n.review-carousel-container .right-control img {\n  transform: rotate(0.5turn);\n}\n\n.review-carousel-container .left-control {\n  margin-right: var(--carousel-control-inner-margin);\n  padding-left: var(--carousel-control-side-padding);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
